import { reducerTypes } from './types';

export const getSelectedLocaleAction = (data: { [key: string]: string }) => ({
  type: reducerTypes.GET_SELECTED_LOCALE,
  payload: data,
});
